<script>

  export let active;
  export let conversation;
  export let updateConversation;
  export let toggleModal;

  import Subheader from './Subheader.svelte';
  import Author from './Author.svelte';
  import Footer from './Footer.svelte';

  import items from '../data/items.js';

  import Certification from '../pages/certification.md';
  import Diversity from  '../pages/diversity.md';
  import Structure from '../pages/profit-structure.md';
  import Development from '../pages/development.md';
  import Transparency from '../pages/transparency.md';
  import Economy from '../pages/blue-economy.md';
  import Measurement from '../pages/measurement.md';

  $: item = items[active];
  $: topic = item.name;
  $: experts = item.expert;
  $: expertID = `${active}${conversation}`
  $: color = item.color;

</script>

<style type="text/sass">

.wrap
  padding: 2em 0 70px
  max-width: 900px
  width: 60vw
  margin: auto

@media (max-width: 800px)
  .wrap
    width: 85vw
    padding-bottom: 50px

</style>

<div style="padding-top: 80px"></div>

{#if item.expert.length > 1}
  <Subheader {color} {experts} {conversation} {updateConversation} />
{/if}

{#if active != 2}
  <Author {expertID} {color} />
{/if}

<div class="wrap" style="--col:{color}">
  {#if active == 0}
    <Certification />
  {:else if active == 1}
    <Diversity />
  {:else if active == 2}
    <Structure />
  {:else if active == 3}
    <Development />
  {:else if active == 4}
    <Transparency />
  {:else if active == 5}
    <Measurement {conversation}/>
  {:else if active == 6}
    <Economy />
  {/if}
</div>

<Footer {color} {toggleModal} />
